export default __webpack_public_path__ + "static/media/logo-white.088aab90.svg";